export const disclosedSalePrice = (enableUndisclosedPrice, property) => {
  return (
    !enableUndisclosedPrice
    && property.isPriceWithheld
    && (property.salePriceIsEdited === undefined || !property.salePriceIsEdited))
    ? 0
    : property.salePrice;
};